/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getCustomercareList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_CUSTOMERCARE, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getCustomercareDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_CUSTOMERCARE_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addCustomercare: (data) => {
    return axios.post(API_ENDPOINTS.ADD_CUSTOMERCARE, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data" },
    });
  },
  updateCustomercare: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_CUSTOMERCARE_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data" },
    });
  },
  deleteCustomercare: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_CUSTOMERCARE_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
